import React, { useState, useEffect } from "react";
import { API } from "aws-amplify";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import moment from "moment";
import { LinkContainer } from "react-router-bootstrap";
import { useHistory } from "react-router-dom";
import queryString from "query-string";

import { useAppContext } from "../libs/contextLib";
import { onError } from "../libs/errorLib";
import LoaderButton from "../components/LoaderButton";

import config from "../config";

function VideoLinkItem(props) {
  //const videoLinkRedirectURL = `${config.apiGateway.URL}/videoLink/${props.item.id}`;
  //const videoLinkRedirectURL = `http://localhost:3000/video/${props.item.id}`;
  const videoLinkRedirectURL = `${config.SITE_URL}/video/${props.item.id}`;

  return (
    <tr>
      <td>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={videoLinkRedirectURL}
        >
          {videoLinkRedirectURL}
        </a>
      </td>
      <td>{props.item.description}</td>
      <td>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={props.item.youtubeUrl}
        >
          {props.item.youtubeUrl}
        </a>
      </td>
      <td>{props.item.premiereTime}</td>
      <td>{props.item.expiryHours}h</td>
      <td>
        <Button
          variant="primary"
          size="sm"
          onClick={() => {
            props.handleEdit(props.item);
          }}
        >
          Edit
        </Button>
      </td>
      <td>
        <LoaderButton
          variant="danger"
          size="sm"
          onClick={() => {
            props.handleDelete(props.item.id);
          }}
        >
          Delete
        </LoaderButton>
      </td>
    </tr>
  );
}

function VideoLinks(props) {
  const [videoLinks, setVideoLinks] = useState([]);
  const { isAuthenticated } = useAppContext();
  const [isLoading, setIsLoading] = useState(true);
  const history = useHistory();

  useEffect(() => {
    async function onLoad() {
      if (!isAuthenticated) {
        return;
      }

      try {
        let videoLinks = await getVideoLinks();
        videoLinks.sort(sortVideoLinksByStartTime);
        setVideoLinks(videoLinks);
      } catch (e) {
        onError(e);
      }

      setIsLoading(false);
    }

    onLoad();
  }, [isAuthenticated]);

  // functio to sort videos by start time
  function sortVideoLinksByStartTime(a, b) {
    return moment(a.premiereTime) - moment(b.premiereTime);
  }

  const handleEdit = (videoLink) => {
    history.push(`/videoLinks/edit?${queryString.stringify(videoLink)}`);
  };

  const handleDelete = async (id) => {
    setIsLoading(true);
    await API.del("api", `/videoLink/${id}`);
    let newVideoLinks = videoLinks.filter((videoLink) => {
      return videoLink.id !== id;
    });
    setVideoLinks(newVideoLinks);
    setIsLoading(false);
  };

  // API CALL GET LINKS
  function getVideoLinks() {
    return API.get("api", "/videoLink/list");
  }

  return (
    <div className="container-fluid">
      <LinkContainer to="/videoLinks/create">
        <Button variant="success" size="sm" className="mb-4">
          Create New Link
        </Button>
      </LinkContainer>
      {isLoading ? (
        <>
          <div>Loading...</div>
        </>
      ) : (
        <>
          {" "}
          <Table striped bordered hover size="sm">
            <thead>
              <tr>
                <th>Link ID</th>
                <th>Title</th>
                <th>Youtube URL</th>
                <th>Start Time</th>
                <th>Expiry</th>
                <th>Modify</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              {videoLinks.map((linkItem) => (
                <VideoLinkItem
                  item={linkItem}
                  isLoading={isLoading}
                  handleEdit={handleEdit}
                  handleDelete={handleDelete}
                  key={linkItem.id}
                ></VideoLinkItem>
              ))}
            </tbody>
          </Table>
        </>
      )}
    </div>
  );
}

export default VideoLinks;

/*
  function getVideoLinks() {
    return API.get("videoLinks", "/videoLinks");
  }*/
